import React from 'react';
import { connect } from 'react-redux';

import SavedSearchList from 'components/saved_search/list';

import { loadSearchQuery, startDeleteSearch } from '../store/actions/saved_searches';
import { getSearches } from '../store/selectors/saved_searches';
import { listFilters } from 'helpers/research/filter_helpers';
export class PropertiesSavedSearchList extends React.Component {
  static propTypes = SavedSearchList.propTypes;

  closeOuterPopover() {
    // TODO: Remove dependency on popover in this component
    document.body.click();
  }

  handleCancel = (search) => {
    this.closeOuterPopover();
    this.props.onDelete(search);
  }

  handleSelect = (search) => {
    this.closeOuterPopover();
    this.props.onSelect(search);
  }

  render() {
    return (
      <SavedSearchList
        {...this.props}
        listFilters={listFilters}
        onDelete={this.handleCancel}
        onSelect={this.handleSelect}
      />
    );
  }
}

const mapStateToProps = state => ({
  searches: getSearches(state)
});

const mapDispatchToProps = {
  onDelete: startDeleteSearch,
  onSelect: loadSearchQuery
};

export default connect(mapStateToProps, mapDispatchToProps)(PropertiesSavedSearchList);
